import { render, staticRenderFns } from "./order-modal-barcode-scanner.vue?vue&type=template&id=234890ca&scoped=true"
import script from "./order-modal-barcode-scanner.vue?vue&type=script&lang=js"
export * from "./order-modal-barcode-scanner.vue?vue&type=script&lang=js"
import style0 from "./order-modal-barcode-scanner.vue?vue&type=style&index=0&id=234890ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234890ca",
  null
  
)

export default component.exports